import { z } from 'zod';
/** Enrich Layer shapes, kept narrow: only the fields the gates actually read. */
export const ExperienceSchema = z.object({
    title: z.string().nullish(),
    company: z.string().nullish(),
    company_linkedin_profile_url: z.string().nullish(),
    starts_at: z
        .object({ day: z.number().nullish(), month: z.number().nullish(), year: z.number().nullish() })
        .nullish(),
    ends_at: z
        .object({ day: z.number().nullish(), month: z.number().nullish(), year: z.number().nullish() })
        .nullish(),
    location: z.string().nullish(),
    description: z.string().nullish(),
});
export const PersonProfileSchema = z.object({
    public_identifier: z.string().nullish(),
    first_name: z.string().nullish(),
    last_name: z.string().nullish(),
    full_name: z.string().nullish(),
    /** Derived "title at company" string. Display only. Never the exported Title. */
    occupation: z.string().nullish(),
    headline: z.string().nullish(),
    summary: z.string().nullish(),
    country: z.string().nullish(),
    country_full_name: z.string().nullish(),
    city: z.string().nullish(),
    state: z.string().nullish(),
    experiences: z.array(ExperienceSchema).nullish(),
    profile_pic_url: z.string().nullish(),
    follower_count: z.number().nullish(),
    meta: z.object({ thin_profile: z.boolean().nullish(), last_updated: z.string().nullish() }).nullish(),
});
export const CompanyProfileSchema = z.object({
    name: z.string().nullish(),
    website: z.string().nullish(),
    industry: z.string().nullish(),
    company_size: z.array(z.number().nullable()).nullish(),
    company_size_on_linkedin: z.number().nullish(),
    hq: z
        .object({ city: z.string().nullish(), state: z.string().nullish(), country: z.string().nullish() })
        .nullish(),
    founded_year: z.number().nullish(),
    linkedin_internal_id: z.string().nullish(),
    universal_name_id: z.string().nullish(),
    follower_count: z.number().nullish(),
    description: z.string().nullish(),
});
//# sourceMappingURL=types.js.map